export default __webpack_public_path__ + "static/media/close-cricle.1b442c1d.svg";